var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 190,
    viewBox: "0 0 191 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M191 55.195V134.805C191 161.5 178.681 179.835 157.002 186.77C150.699 188.955 143.441 190 135.515 190H55.4855C47.559 190 40.301 188.955 33.998 186.77C12.3195 179.835 0 161.5 0 134.805V55.195C0 20.615 20.7235 0 55.4855 0H135.515C170.277 0 191 20.615 191 55.195Z",
    fill: "#009240"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.008 186.77C150.705 188.955 143.447 190 135.521 190H55.4914C47.5649 190 40.3069 188.955 34.0039 186.77C37.3464 161.69 63.7044 142.215 95.5054 142.215C127.307 142.215 153.666 161.69 157.008 186.77Z",
    fill: "#009240"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.688 91.01C129.688 109.82 114.408 125.115 95.4994 125.115C76.5904 125.115 61.3105 109.82 61.3105 91.01C61.3105 72.2002 76.5904 57 95.4994 57C114.408 57 129.688 72.2002 129.688 91.01Z",
    fill: "#009240"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.ae6f2c0a21f9c81d1a659c44cefb20a6.svg";
export { ForwardRef as ReactComponent };